import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment/locale/pt-br' // without this line it didn't work

import { Link, graphql, navigate } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'
import decodeEntities from '../util/textDecode'
import categoriesMetadata from '../hooks/QueryCategories'
import { device } from './Breakpoints'
import { colors } from './Colors'

const Container = styled.section`
  width: 100%;
  .filters {
    padding: 1em;
    background: ${colors.lilasGradienteHorizontal};
    .center {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;

      @media ${device.mobileL} {
        justify-content: center;
      }
      span {
        list-style: none;
        color: #ffffff;
        margin-right: 1em;
      }
      select {
        padding: 0.5em 1em;
        margin-right: 2em;
        border-radius: 5px;
        border: 1px solid #eaeaea;
        color: #9091c8;
        min-width: 180px;
        @media ${device.mobileL} {
          margin: 0.5em;
        }
      }
    }
  }
  .center {
    max-width: 1114px;
    margin: auto;
    @media ${device.mobileL} {
      max-width: 100%;
      text-align: center;
    }
    h2 {
      text-align: left;
      margin-top: 1em;
      margin-bottom: 0.4em;

      @media ${device.mobileL} {
        text-align: center;
      }
    }
  }
  h2 {
    margin-top: 2em;
    text-align: center;
    color: ${colors.verde};
    font-size: 1.2em;
  }
  ul.posts {
    padding: 0;
    margin: 2em 0 0;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    @media ${device.mobileL} {
      margin: 2em;
    }
    li {
      list-style: none;
      padding: 0;
      background: #fff;
      border: 1px solid #ebebea;
      margin-bottom: 5px;
      width: 33.33%;
      box-sizing: border-box;
      padding: 2em;
      justify-content: flex-start;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      @media ${device.mobileL} {
        width: 100%;
      }
      .thumb {
        margin: -2em -2em 1.5em;
        overflow: hidden;
        max-height: 212px;
        display: block;
        width: 370px;
        img.gatsby-image-wrapper,
        img {
          width: 100%;
        }
      }
      small {
        font-size: 0.6em;
        padding: 0.5em 0;
      }
      h3 {
        margin: 0.6em 0;
        display: block;
        width: 100%;
        font-size: 1em;
        a {
          color: ${colors.lilas};
          text-decoration: none;
          display: block;
        }
      }
      p {
        font-size: 0.6em;
      }
    }
  }
  ul.categories {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    li {
      margin-right: 0.5em;
      border: 0;
      padding: 0.5em 0.8em;
      border-radius: 5px;
      width: auto;
      color: #ffffff;
      font-size: 0.6em;
    }
    li.Laranja {
      background: ${colors.laranjaCategoria};
    }
    li.Verde {
      background: ${colors.verdeCategoria};
    }
    li.Amarelo {
      background: ${colors.amareloCategoria};
    }
    li.Lilas {
      background: ${colors.lilasCategoria};
    }
  }
`

const IndexPage = ({ posts }) => {
  const categories = categoriesMetadata()
  const filterPage = target => {
    const page = target.value
    navigate(`${page}/#filters`)
  }

  return (
    <Container>
      <div className="center">
        <h2 id="filters">Filtre sua busca</h2>
      </div>
      <div className="filters">
        <div className="center">
          <span>Categorias</span>

          <select onChange={e => filterPage(e.target)}>
            <option>-</option>
            <option value="/blog">Todas</option>
            {categories.map(({ node: cat }) => (
              <option value={`/categorias/${cat.slug}`} key={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>

          <span>Filtrar por:</span>
          <select onChange={e => filterPage(e.target)}>
            <option>-</option>
            <option value="/blog">Mais recentes</option>
            <option value="/blog/asc">Mais antigos</option>
          </select>
        </div>
      </div>
      <div className="center">
        <ul className="posts">
          {posts.map(post => (
            <li key={post.id}>
              <Link to={`/blog${post.uri}`} className="thumb">
                {post.featuredImage ? (
                  <Img
                    fluid={
                      post.featuredImage.node.localFile.childImageSharp.fluid
                    }
                    alt={post.title}
                  />
                ) : (
                  <img
                    src={
                      post.categories.nodes[0].categorias.imagemPadrao.sourceUrl
                    }
                    alt={post.title}
                  />
                )}
              </Link>
              <ul className="categories">
                {post.categories.nodes.map(cat => (
                  <li
                    key={cat.id}
                    className={
                      cat.categorias !== null ? cat.categorias.color : 'Laranja'
                    }
                  >
                    {cat.name}
                  </li>
                ))}
              </ul>
              <small>
                {moment(post.date)
                  .locale('pt-br')
                  .local()
                  .format('MMM DD, YYYY')}
              </small>
              <h3>
                <Link to={`/blog${post.uri}`}>
                  {decodeEntities(post.title)}
                </Link>
              </h3>
              <div
                dangerouslySetInnerHTML={{
                  __html: post.excerpt.replace(/<p class="link-more.*/, ''),
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    </Container>
  )
}

IndexPage.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
}

export const pageQuery = graphql`
  fragment PostListFields on wp__POST {
    id
    title
    excerpt
    date
    slug
    uri
    categories {
      id
      name
      categorias {
        color
        imagemPadrao {
          sourceUrl
          localFile {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
    featuredImage {
      node {
        sourceUrl
        localFile {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`
export default IndexPage
